const invalidFileNameCharsRegex = /[<>:"/\\|?*]/u;
const reservedWindowsFileNamesRegex = /^(con|prn|aux|nul|com[1-9]|lpt[1-9])$/iu;

export type InvalidFileNameReason =
    | "empty"
    | "invalid-character"
    | "control-character"
    | "reserved-windows-name"
    | "ends-with-dot"
    | "ends-with-space";

export type FileNameValidationResult = 
    | { isValid: true; }
    | { isValid: false; reason: InvalidFileNameReason;
};

const hasControlCharacter = (name: string): boolean => (
    [...name].some((char) => {
        const charCode = char.charCodeAt(0);
        return charCode >= 0 && charCode <= 31;
    })
);

export const validateFileName = (name: string): FileNameValidationResult => {
    if(name === "") {
        return {
            isValid: false,
            reason: "empty",
        };
    }

    if(invalidFileNameCharsRegex.test(name)) {
        return {
            isValid: false,
            reason: "invalid-character",
        };
    }

    if(hasControlCharacter(name)) {
        return {
            isValid: false,
            reason: "control-character",
        };
    }

    if(reservedWindowsFileNamesRegex.test(name)) {
        return {
            isValid: false,
            reason: "reserved-windows-name",
        };
    }

    if(name.endsWith(".")) {
        return {
            isValid: false,
            reason: "ends-with-dot",
        };
    }

    if(name.endsWith(" ")) {
        return {
            isValid: false,
            reason: "ends-with-space",
        };
    }

    return {
        isValid: true,
    };
};

export const getInvalidFileNameMessage = (reason: InvalidFileNameReason): string => {
    switch(reason) {
        case "empty":
            return "Le nom ne peut pas être vide";
        case "invalid-character":
            return "Le nom contient un caractère interdit";
        case "control-character":
            return "Le nom contient un caractère de contrôle interdit";
        case "reserved-windows-name":
            return "Ce nom est réservé par Windows";
        case "ends-with-dot":
            return "Le nom ne peut pas se terminer par un point";
        case "ends-with-space":
            return "Le nom ne peut pas se terminer par un espace";
        default:
            return "Le nom est invalide";
    }
};